import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Member } from 'src/app/model/member.model';
import { Balance } from 'src/app/model/balance.model';
import { BalanceService } from './balance.service';
import { DateService } from 'src/app/core/service/date.service';
import { AuthenticationService } from 'src/app/core/service/authentication.service';
import { Subscription } from 'rxjs';
import { OptionListService } from 'src/app/core/service/optionList.service';
import Swal from 'sweetalert2';
import liff from '@line/liff';

@Component({
  selector: 'app-balance',
  templateUrl: './balance.component.html',
  styleUrls: ['./balance.component.css'],
})
export class BalanceComponent implements OnInit {
  CompanyID: string;
  UserID: string;
  Liff_ID: string;
  UserName: string;
  LoginUser: Member;
  editModel: Balance; //預覽表單
  Balance: number;
  isOptionLoading = false;
  showDs = false;
  subscribes: Subscription = new Subscription();
  constructor(
    private route: ActivatedRoute,
    private BalanceService: BalanceService,
    private DateService: DateService,
    private authenticationService: AuthenticationService,
    private OptionListService: OptionListService
  ) {}

  ngOnInit(): void {
    var that = this;
    // 取得querystring param
    var query = this.route.queryParams.subscribe((value) => {
      this.CompanyID = value['CompanyID'];
      this.UserID = value['UserID'];
      this.Liff_ID = value['Liff_ID'];
    });
    
    var currentUser = this.authenticationService.currentMember.subscribe(
      (member) => {
        this.LoginUser = member;
      }
    );
    
    this.subscribes.add(query);
    this.subscribes.add(currentUser);
    this.subscription();
  }
  //#region  初始化
  subscription() {
    this.isOptionLoading = true;
    var defaultValue = this.BalanceService.GetDefaultValue(this.CompanyID,this.UserID).subscribe((res)=> this.GetDefaultValueSucceed(res));
  
    this.subscribes.add(defaultValue);
  }
  //#endregion

  //#region 按鈕事件
  ShowDetails() {
    this.isOptionLoading = true;
    const details = this.BalanceService.GetDetails(this.CompanyID,this.UserID).subscribe((res)=> this.GetDetailsSucceed(res));
    this.subscribes.add(details);
    this.showDs = true;
  }

  //#endregion
  
  //#region 資料處理
 
  GetDefaultValueSucceed(res: any): void {
    if(!!res.ErrorFlag == true && res.ErrorFlag == '1'){
      Swal.fire({
        icon: 'error',
        title: res.ErrorMsg,
      });
      this.isOptionLoading = false;
      return;
    }else{
      this.editModel = new Balance();
      this.Balance = res['ValidAmount'];
      this.LoginUser.MemberNo = res['MemberNo'];
      this.isOptionLoading = false;
    }
  }

  GetDetailsSucceed(res: any): void {
    if(!!res.ErrorFlag == true && res.ErrorFlag == '1'){
      Swal.fire({
        icon: 'error',
        title: res.ErrorMsg,
      });
      this.isOptionLoading = false;
      return;
    }else{
      this.editModel.AddValues = res['AddValues'];
      this.editModel.Consumptions = res['Consumptions'];
      this.isOptionLoading = false;
    }
  }
  //#endregion
  
  //#region 驗證
  

  //#endregion

  ngOnDestroy() {
    this.subscribes.unsubscribe();
  }
}
